import buildAsyncCall from './asyncCall'
import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'

const Types = {
    DASHBOARD_PLAYLISTS_LATEST: {
        request: 'DASHBOARD_PLAYLISTS_LATEST##REQUEST',
        success: 'DASHBOARD_PLAYLISTS_LATEST##SUCCESS',
        failure: 'DASHBOARD_PLAYLISTS_LATEST##FAILURE',
    },
    DASHBOARD_PLAYLISTS_SCHEDULED_NEXT: {
        request: 'DASHBOARD_PLAYLISTS_SCHEDULED_NEXT##REQUEST',
        success: 'DASHBOARD_PLAYLISTS_SCHEDULED_NEXT##SUCCESS',
        failure: 'DASHBOARD_PLAYLISTS_SCHEDULED_NEXT##FAILURE',
    },
}

function fetchPlaylistsLatest() {
    return buildAsyncCall({
        endpoint: `${HUBBLE_API_TOKEN}/dashboard/playlists/latest`,
        method: 'GET',
        types: [Types.DASHBOARD_PLAYLISTS_LATEST.request, Types.DASHBOARD_PLAYLISTS_LATEST.success, Types.DASHBOARD_PLAYLISTS_LATEST.failure],
    })
}

function fetchPlaylistsScheduledNext() {
    return buildAsyncCall({
        endpoint: `${HUBBLE_API_TOKEN}/dashboard/playlists/scheduled/next`,
        method: 'GET',
        types: [
            Types.DASHBOARD_PLAYLISTS_SCHEDULED_NEXT.request,
            Types.DASHBOARD_PLAYLISTS_SCHEDULED_NEXT.success,
            Types.DASHBOARD_PLAYLISTS_SCHEDULED_NEXT.failure,
        ],
    })
}

export { Types, fetchPlaylistsLatest, fetchPlaylistsScheduledNext }
